<div class="posterCard">
    <a class="posterImage" (click)="onClick()" routerLinkActive="router-link-active" >
        <img [src]="promo?.image" alt="">
        <div *ngIf="promo?.title != ''" class="title"> 
            {{promo?.title }}
        </div>
    </a>
    <div class="add">
    </div>
    <!-- <div class="buttons">
        <div class="bookNow">
            Book Now
        </div>
        <a  [routerLink]="['/movies/', movie?.Dx ]">
            <div class="info">
                Info
            </div>
        </a>   
    </div> -->
</div>
